import React, {PureComponent} from 'react';

import * as validation from '../../lib/validation';
import Input from '../../components/Input';
import Form from '../../components/Form';
import SideModal from '../../components/SideModal';
import Button from '../../components/Button';

let tmpId = 0;

class CatalogItemForm extends PureComponent {
  state = this.getInitialState();

  getInitialState() {
    return {
      validate: !!this.props.item,
      saving: false,
      item: this.props.item || {
        id: tmpId++,
        tmp: true,
        name: '',
        type: null,
        parentId: this.props.parent ? this.props.parent.id : null
      }
    };
  }

  // Validation rules
  validName = validation.create((name, {isEmpty}) => !this.state.validate || !isEmpty(name));
  validType = validation.create(type => !this.state.validate || !!type);
  validItem = validation.validate({
    name: this.validName,
    type: this.validType
  });

  componentDidUpdate(prevProps) {
    const {item, parent} = this.props;

    if (prevProps.item !== item || prevProps.parent !== parent) {
      this.setState(this.getInitialState());
    }
  }

  updateItem = fields => {
    this.setState(state => ({item: {...state.item, ...fields}}));
  }

  handleSave = () => {
    this.setState({validate: true}, async () => {
      const {item} = this.state;
      const {onSave} = this.props;

      if(!this.validItem(item)) {
        return;
      }

      this.setState({saving: true});
      
      if (!await onSave(item)) {
        this.setState({saving: false});
      }
    });
  }

  render() {
    const {item, saving} = this.state;
    const {types, open, onClose} = this.props;
    return (
      <Form onSubmit={this.handleSave}>
        <SideModal
          title={item.tmp ? 'New Catalog Item' : 'Edit Catalog Item'}
          open={open}
          onClose={onClose}
          options={[
            <Button type="submit" disabled={saving}>Save Catalog Item</Button>,
            <Button secondary onClick={onClose}>Cancel</Button>
          ]}>
          <SideModal.Content>
            <Form.Group>
              <Input
                required
                type="text"
                id="catalog-item-name"
                label="Name"
                value={item.name}
                onChange={e => this.updateItem({name: e.target.value})}
                invalid={!this.validName(item.name)}
                validationText="Please enter a name"
              />
            </Form.Group>
            <Form.Group>
              <Input
                required
                type="select"
                id="catalog-item-type"
                label="Type"
                value={item.type ? item.type.id : ''}
                onChange={e => this.updateItem({type: types.filter(type => type.id === e.target.value)[0]})}
                invalid={!this.validType(item.type)}
                validationText="Please choose a type">
                <option value="">Choose a catalog type...</option>
                {types.map(type => (
                  <option key={type.id} value={type.id}>{type.name}</option>
                ))}
              </Input>
            </Form.Group>
            {item.dates && item.dates.createdDate && 
              <p>Created: {new Date(item.dates.createdDate).toLocaleString()}</p>}
            {item.dates && item.dates.lastModifiedDate && 
              <p>Last Modified: {new Date(item.dates.lastModifiedDate).toLocaleString()}</p>}
          </SideModal.Content>
        </SideModal>
      </Form>
    );
  }
}

export default CatalogItemForm;